import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initializeI18n } from './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const bootstrap = async () => {
  await initializeI18n();

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

void bootstrap();

reportWebVitals();
